import React from 'react'
import Navbar from './Navbar'
import { Outlet} from 'react-router-dom'
import './CategoryLayout.css'
import Navbar2 from './Navbar2'
import Footer from './Footer/Footer'

function CategoryLayout() {
  return (
    <div className='category-layout'>
        <Navbar/>
        <div className="sticky-navbar">
        <Navbar2 />
        </div>
        <div className="category-content">
            <Outlet/>
        </div>
        <Footer/>
    </div>
  )
}

export default CategoryLayout